export enum SortBy {
    MostPopular = "MostPopular",
    LowestPrice = "LowestPrice",
    HighestPrice = "HighestPrice",
    FinancialStrength = "FinancialStrength",
    PolicyFeatures = "PolicyFeatures",
    CustomerService = "CustomerService"
}

export type SortDirection = "asc" | "desc";

export default SortBy;
